import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { CDN_URL, formatMoney, formatMoneyShorten, getCurrentYear } from "../Helpers";
import { FaAndroid, FaApple, FaArrowCircleRight, FaChalkboardTeacher, FaGlobe } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCheck, MdLocationPin, MdSearch } from "react-icons/md";

export default function OneService({ data }) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ ready, setReady ] = useState(false);

  function view() {
    appContext.navTo({
      item: 'view',
      subItem: 'gallery',
      extraItem: data.uuid,
    })
  }

  const photoUrl = (data && data.photo) ? (CDN_URL + data.photo) : "";

  return (
    <div
      className=""
      style={{
        cursor: "pointer",
        borderRadius: "14px",
        overflow: "hidden",
        marginBottom: "18px",
        background: "#000",
        position: "relative",
        boxShadow: "0 10px 26px rgba(0,0,0,0.12)",
        transition: "transform 160ms ease, box-shadow 160ms ease",
      }}

      onClick={() => {
        view();
      }}

      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.015)";
        e.currentTarget.style.boxShadow = "0 18px 46px rgba(0,0,0,0.18)";
      }}

      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow = "0 10px 26px rgba(0,0,0,0.12)";
      }}
    >

      {/* Image */}
      <div
        style={{
          width: "100%",
          height: "320px",
          backgroundImage: photoUrl ? `url(${photoUrl})` : "none",
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          position: "relative",
          backgroundColor: "rgba(0,0,0,0.12)",
        }}
      >

        {/* Vertical fade (different from event/project) */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(180deg, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.15) 45%, rgba(0,0,0,0.85) 100%)",
          }}
        />

        {/* Floating corner indicator */}
        <div
          style={{
            position: "absolute",
            top: "12px",
            right: "12px",
            padding: "6px 10px",
            borderRadius: "10px",
            background: "rgba(0,0,0,0.45)",
            border: "1px solid rgba(255,255,255,0.18)",
            backdropFilter: "blur(8px)",
            color: "rgba(255,255,255,0.9)",
            fontSize: "11px",
            letterSpacing: "0.6px",
          }}
          className="font-semi-bold"
        >
          GALLERY
        </div>

        {/* Bottom description */}
        <div
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            padding: "14px",
          }}
        >
          <h6
            style={{
              fontSize: "15px",
              margin: 0,
              color: "#fff",
              lineHeight: "1.45",
              textShadow: "0 8px 22px rgba(0,0,0,0.45)",
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            className="font-bold"
          >
            {data.description}
          </h6>

          {/* Subtle hint */}
          <div
            style={{
              marginTop: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "10px"
            }}
          >
            <div
              style={{
                fontSize: "12px",
                color: "rgba(255,255,255,0.75)",
              }}
              className="font-semi-bold"
            >
              View photos
            </div>

            <div
              style={{
                width: "32px",
                height: "32px",
                borderRadius: "999px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "rgba(255,255,255,0.14)",
                border: "1px solid rgba(255,255,255,0.18)",
              }}
            >
              <FaArrowCircleRight
                style={{
                  color: "rgba(255,255,255,0.9)",
                  fontSize: "16px"
                }}
              />
            </div>
          </div>

        </div>

      </div>

    </div>
  )

}
